import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'statusColor',
})
export class StatusColorPipe implements PipeTransform {
  transform(value: unknown): unknown {
    switch (value) {
      case 'COMPLETED':
        return 'primary';
        break;
      case 'ACTIVE':
        return 'success';
        break;
      case 'CANCELLED':
        return 'danger';
        break;
    }
  }
}
